import {IRoutableModule} from '../../router/routing.infra';
import {EmbeddedDashboardGeneralErrorView} from './embedded-dashboard-general-error.view';
import {embeddedDashboardGeneralErrorRouteLoader} from './embedded-dashboard-general-error.loader';

export default {
    loader: embeddedDashboardGeneralErrorRouteLoader,
    Component: EmbeddedDashboardGeneralErrorView,
    storeAs: 'embeddedDashboardGeneralErrorStore'
} as IRoutableModule;
